import { SVGProps } from 'react';

export const HashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={18} viewBox="0 0 16 18" fill="none" {...props}>
    <path
      stroke="#38363D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 6h14M1 12h14M7 1 3 17M13 1 9 17"
    />
  </svg>
);
